<template>
  <v-dialog v-model="dialog" width="500">
    <v-card v-if="cart != null">
      <v-card-text>
        <v-expansion-panel>
          <v-expansion-panel-content v-for="(cartEl, i) in cart" :key="i">
            <div slot="header" style="display: flex; width: calc(100% - 40px);">
              <div>{{cartEl.quant}} X {{cartEl.prod.descrizione}}</div>
              <v-spacer></v-spacer>
              <div><v-icon>euro_symbol</v-icon>{{getPrice(cartEl.prod.prezzo)}}</div>
            </div>
            <v-card>
              <v-card-text class="grey lighten-3">
                <v-list-tile 
                  :class="{'orange--text': vari.quant == 1,
                           'white--text': vari.quant > 1,
                           'grey--text': vari.quant == 0, 
                           'red--text': vari.quant == -1}" 
                  :key="`${i}_${y}`" v-for="(vari, y) in cartEl.prod.varianti">
                  <div>
                    <span v-if="vari.quant > 0">{{vari.quant}} X&nbsp;</span> 
                    {{vari.descrizione}}
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                    <v-icon class="orange--text">{{getPriceType(vari.prezzo) == 1 ? 'euro_symbol' : 'fa-percent'}}</v-icon>
                    &nbsp;
                    {{getVarPrice(vari.quant, vari.prezzo)}}
                  </div>
                </v-list-tile>
                <h5 class="mb-0" v-if="cartEl.prod.varianti.length == 0">Nessuna variante</h5>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <h5 class="mt-4 dflex">TOTALE: <v-spacer></v-spacer> <v-icon>euro_symbol</v-icon>{{getTotale()}}</h5>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="green--text darken-1" flat="flat" @click.native="close">Annulla</v-btn>
        <v-btn class="green--text darken-1" flat="flat" v-if="settings.payment.when == 'PAGADOPO'" @click.native="checkout()">Invia</v-btn>
        <v-btn class="green--text darken-1" flat="flat" v-if="settings.payment.when == 'PAGAORA' &&  settings.payment.how.braintree" @click.native="checkout('BRAINTREE')">Braintree</v-btn>
        <v-btn class="green--text darken-1" flat="flat" v-if="settings.payment.when == 'PAGAORA' && settings.payment.how.card" @click.native="checkout('PREPAIDCARD')">Tessera</v-btn>
        <v-btn class="green--text darken-1" flat="flat" v-if="settings.payment.when == 'PAGAORA' && settings.payment.how.safePayAfter" @click.native="checkout('SAFEPAYAFTER')">Da confermare</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Dialog che mostra il carrello attuale
 * @module components/common/ShowCart
 */
export default {
    name: 'showCart',
    data () {
      return {
        cart: null
      }
    },
    methods: {
      close () {
        this.$emit('close', null)
      },
      checkout (method) {
	      this.$emit('checkout', method)
        this.$emit('close', null)
      },
      getPrice (price) {
        return utils.toNumeral(price.prezzop).toShow()
      },
      getVarPrice (quant, price) {
        if(quant > 0)
          return utils.toNumeral(price.prezzop).toShow()
        else
          return utils.toNumeral(price.prezzom).toShow()
      },
      getPriceType (price) {
        return price.tipo
      },
      getTotale(){
        return utils.toNumeral(this.calcolo(this.cart, numeral)).toShow()
      }
    },
    watch: {
      showCart (newV) {
        if(newV){
          this.cart = this.cartContent
        }else
          this.cart = null
      }
    },
    computed: {
      dialog: {
        get () {
          return this.showCart
        },
        set () {
          this.$emit('close')
        }
      }
    },
    /**
     * @prop cartContent {array} - Contenuto del carrello
     * @prop showCart {boolean} - Gestisce la visibilita del dialog
     * @prop calcolo {function} - Funzione per il calcolo del totale
     */
    props: ['cartContent', 'showCart', 'calcolo', 'settings']
}
</script>

<style lang="stylus" scoped>
.expansion-panel
  max-height: 300px
  overflow-y: auto
</style>



// WEBPACK FOOTER //
// src/components/common/ShowCart.vue